import { render, staticRenderFns } from "./variants-selector.vue?vue&type=template&id=617b58e6&lang=pug&"
import script from "./variants-selector.vue?vue&type=script&lang=js&"
export * from "./variants-selector.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports